import { create } from 'zustand';

export type ConnState = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

interface ConnectionStore {
  status: ConnState;
  sessionId: string | null;
  lastConnectedAt: number | null;
  setStatus: (s: ConnState) => void;
  setSession: (id: string) => void;
}

export const useConnection = create<ConnectionStore>((set) => ({
  status: 'disconnected',
  sessionId: null,
  lastConnectedAt: null,
  setStatus: (status) =>
    set((s) => ({
      status,
      lastConnectedAt: status === 'connected' ? Date.now() : s.lastConnectedAt,
    })),
  setSession: (sessionId) => set({ sessionId }),
}));
